import { useDispatch, useSelector } from "react-redux";
import Activity from "components/activity/activity";
import { useEffect, useState } from "react";
import { setTitleBar } from "store/titleBar.slice";
import { useTranslation } from "react-i18next";
import { useWebsocketsService } from "hook/useWebsockets";
import { DownloadedActivityModel, type downloadedType } from "models/downloadedActivity.model";
import type { ModalType } from "parts/modal/modal";
import modalUtil, { sanitizeId } from "utils/modal.util";
import { Button } from "react-bootstrap";
import { closeModal } from "store/modal.slice";
import type { activityType } from "models/activity.model";


const Downloads = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { deleteActivityOffline, getActivityOffline, lastMessage } = useWebsocketsService();
    const [filteredData, setFilteredData] = useState<activityType[]>([]);
    const searchBarFilteredData: activityType[] = useSelector((state: any) => state.titleBar.filteredData);

    function validateDeletionActivity(activity: activityType): void {

        function deleteActivity(): void {
            deleteActivityOffline(activity);
        }

        const modalData: ModalType = {
            id: sanitizeId(t("delete_activity")),
            title: t("delete_activity"),
            text: [`${t("delete_activity_confim_1")} "${activity.title}" ${t("delete_activity_confim_2")}`],
            status: "neutre",
            position: "middle",
            blocking: true,
            buttons: [
                <Button key="no" variant="light" className="btn_light" onClick={() => dispatch(closeModal())}>
                    {t('no')}
                </Button>,
                <Button key="yes" className="btn_primary" onClick={deleteActivity}>
                    {t('yes')}
                </Button>
            ],
            autoClose: false,
        };
        modalUtil.show(modalData, dispatch);
    }

    useEffect(() => {
        getActivityOffline();
        return () => {
            dispatch(setTitleBar({ 
                title: "", 
                data: [], 
                filteredData: [],
                isBackButton: false,
                isSearchBar: true,
                overrideSearchFn: false,
            }));
        }
    }, [])

    useEffect(() => {
        if (lastMessage) {
            const { id, success, data } = JSON.parse(lastMessage.data);

            if (id === "list") {
                let activities: activityType[] = [];
                data.map((r: downloadedType) => activities = [...activities, new DownloadedActivityModel(r)])

                dispatch(setTitleBar({ title: "title_activities_offline", data: activities, filteredData: activities }));

            }
            if (id === "deleteStatus") {
                const modalData: ModalType = {
                    id: sanitizeId(success ? t("delete_activity_success") : t("delete_activity_error")),
                    title: success ? t("delete_activity_success") : t("delete_activity_error"),
                    text: success ? [] : [data],
                    status: success ? "success" : "error",
                    position: "bottomRight",
                    blocking: !success,
                    buttons: [],
                    autoClose: success,
                };

                modalUtil.show(modalData, dispatch);

                if (success)
                    getActivityOffline();
            }
        }
    }, [lastMessage]);

    useEffect(() => {
        setFilteredData(searchBarFilteredData);
    }, [searchBarFilteredData])


    return (
        <div className="activities">
            <div className="activities__section">
                <div className="activities__section__items seeMore">
                    {filteredData && filteredData.map((activity, idx) => {
                        return <Activity key={idx} activity={activity} deleteActivity={validateDeletionActivity} />
                    })}

                </div>
            </div>
        </div>
    );
};

export default Downloads;